// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__ZgBzR","visible":"Section_visible__yk7vj"};